import {
  Bar,
  BarChart,
  CartesianGrid,
  LabelList,
  ResponsiveContainer,
  XAxis,
  YAxis,
} from 'recharts';
import { DashboardWidget } from './DashboardWidget';
import type { NameValueItem } from './types';

type ApplicationsByStateChartProps = {
  data: NameValueItem[];
  loading?: boolean;
  title?: string;
};

const renderBarLabel = (props: {
  x?: number;
  y?: number;
  width?: number;
  value?: number;
}) => {
  const {
    x = 0,
    y = 0,
    width = 0,
    value,
  } = props;

  if (value === undefined || value === null) return null;

  return (
    <text
      x={x + width / 2}
      y={y + 18}
      fill="#ffffff"
      textAnchor="middle"
      fontSize={12}
      fontWeight={700}
    >
      {value}
    </text>
  );
};

export const ApplicationsByStateChart = ({
  data,
  loading = false,
  title = 'SOLICITUDES DE DESEMBOLSO POR ESTADO',
}: ApplicationsByStateChartProps) => (
  <DashboardWidget title={title} loading={loading} hasData={data.length > 0}>
    <div style={{ width: '100%', height: 290 }}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          data={data}
          margin={{
            top: 10,
            right: 20,
            left: 10,
            bottom: 20,
          }}
          barCategoryGap="22%"
        >
          <CartesianGrid stroke="#e3e3e3" vertical={false} />

          <XAxis
            dataKey="name"
            tick={{ fontSize: 12, fill: '#4a4a4a' }}
            axisLine={{ stroke: '#cfcfcf' }}
            tickLine={false}
            interval={0}
          />

          <YAxis
            tick={{ fontSize: 12, fill: '#4a4a4a' }}
            axisLine={false}
            tickLine={false}
          />

          <Bar dataKey="value" fill="#2f89d8" barSize={90}>
            <LabelList dataKey="value" content={renderBarLabel} />
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  </DashboardWidget>
);
